import React from 'react';
import Lightbox from 'react-awesome-lightbox';
import 'react-awesome-lightbox/build/style.css';

import { Gavel } from 'lucide-react';
import '../../../styles/components/category-auctions.scss';
import i18n from '../../../i18n';
import { getAuctionChartData } from '../../../models/auctions';
import { CustomTitle } from '../../helpers/customTitle';
import { AllAuctions } from '../auctionsCategory/all';
import { ActiveAuctions } from '../auctionsCategory/active';
import { UpcomingAuctions } from '../auctionsCategory/upcoming';
import { FeaturedAuctions } from '../auctionsCategory/featured';
import { PreviousAuctions } from '../auctionsCategory/previous';
import { DirectAuctions } from '../auctionsCategory/direct';

export class CategoryAuctionsNew extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedTab: 'active',
      active_count: 0,
      upcoming_count: 0,
      firstload: true,
      secondLoad: false,
      tabs: [
        {
          name: i18n.t('active_auctions'),
          tab: 'active',
        },
        {
          name: i18n.t('upcoming_auctions'),
          tab: 'upcoming',
        },
        {
          name: i18n.t('previous_auctions'),
          tab: 'previous',
        },
        {
          name: i18n.t('all_auctions'),
          tab: 'all',
        },
        {
          name: i18n.t('direct_sale'),
          tab: 'direct',
        },
      ],
      lightboxImages: [],
      is_active_light_box: false,
      counts: {},
      is_loading_1: false,
      isMobile: window.innerWidth <= 992,
    };
    this.dropdownRef = React.createRef();
    this.handleTabs = this.handleTabs.bind(this);
    this.getActiveCount = this.getActiveCount.bind(this);
    this.getUpcomingCount = this.getUpcomingCount.bind(this);
    this.getImagePopup = this.getImagePopup.bind(this);
    this.loadAuctionsCount = this.loadAuctionsCount.bind(this);
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    let tab = params.get('tab'); // get from URL

    // If tab is null/undefined or invalid, use default selectedTab
    if (!tab || !this.state.tabs.some((t) => t.tab === tab)) {
      tab = this.state.selectedTab;

      // Update URL with default tab
      const url = new URL(window.location);
      url.searchParams.set('tab', tab);
      window.history.replaceState({}, '', url);
    }

    // Set state with selected tab
    this.setState({ selectedTab: tab });

    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('touchstart', this.handleClickOutside);
    this.loadAuctionsCount();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('touchstart', this.handleClickOutside);
  }
  updateTabFromURL = () => {
    const params = new URLSearchParams(this.props.location.search);
    let tab = params.get('tab');

    // If tab is missing or invalid, use default selectedTab
    if (!tab || !this.state.tabs.some((t) => t.tab === tab)) {
      tab = this.state.selectedTab;
      const url = new URL(window.location);
      url.searchParams.set('tab', tab);
      window.history.replaceState({}, '', url);
    }

    this.setState({ selectedTab: tab });
  };
  handleClickOutside = (event) => {
    // Ensure dropdownRef exists and event target is outside the dropdown
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      // Close the mobile dropdown
      if (this.state.auctionDropdownOpen) {
        this.setState({ auctionDropdownOpen: false });
      }
    }
  };

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 992 });
  };

  handleTabs(tabname) {
    this.setState({ selectedTab: tabname }, () => {
      const url = new URL(window.location);
      url.searchParams.set('tab', tabname);
      window.history.replaceState({}, '', url); // updates URL without reloading
    });
  }

  getActiveCount(count) {
    if (count === 0 && this.state.firstload) {
      this.setState({
        selectedTab: 'upcoming',
        firstload: false,
        secondLoad: true,
      });
    }
  }

  getUpcomingCount(count) {
    if (count === 0 && this.state.secondLoad) {
      this.setState({ selectedTab: 'previous', secondLoad: false });
    }
  }

  getImagePopup(active, images) {
    let lightboxImages = [];
    if (images) {
      images.forEach(function (arrayItem) {
        lightboxImages.push({
          url: arrayItem.image,
        });
      });
    }
    this.setState({
      is_active_light_box: active,
      lightboxImages: lightboxImages,
    });
  }

  async loadAuctionsCount() {
    this.setState({ is_loading_1: true });
    let counts = {};
    const response = await getAuctionChartData('main');
    let data = response.data;
    if (response) {
      counts = {
        active: data.active,
        upcoming: data.upcoming,
        previous: data.previous,
        featured: data.featured,
        direct: data.direct,
        all: Number(data.previous) + Number(data.active),
      };
      this.setState({
        is_loading_1: false,
        counts,
      });
    }
  }

  render() {
    let selectedTab = this.state.selectedTab;
    let tabs = this.state.tabs;

    return (
      <React.Fragment>
        <section className="category-auctions-section">
          <div className="container-fluid">
            {/* Section Title */}
            <div className="auctions-header">
              <CustomTitle title={i18n.t('auctions')} icon={Gavel} />
            </div>

            {/* Auction Tabs */}
            <div className="auctions-tabs-container">
              {/* Desktop Tabs */}
              {!this.state.isMobile ? (
                <div className="auctions-tabs-wrapper">
                  {tabs.map((item, i) => {
                    return (
                      <div
                        key={i}
                        className={`auction-tab ${selectedTab === item.tab ? 'active' : ''}`}
                        onClick={() => this.handleTabs(item.tab)}
                      >
                        <span className="tab-label">{item.name}</span>
                        <span className="tab-count">
                          {this.state.is_loading_1 ? (
                            <span className="count-loader"></span>
                          ) : (
                            this.state.counts[item.tab] || 0
                          )}
                        </span>
                      </div>
                    );
                  })}
                </div>
              ) : (
                /* Mobile Dropdown */
                <div className="auction-tab-dropdown">
                  <div className="auction-filter-dropdown" ref={this.dropdownRef}>
                    <button
                      className="auction-filter__trigger"
                      onClick={(e) => {
                        e.stopPropagation(); // stop bubbling to document
                        this.setState({
                          auctionDropdownOpen: !this.state.auctionDropdownOpen,
                        });
                      }}
                      aria-expanded={this.state.auctionDropdownOpen}
                    >
                      <span className="auction-filter__label">
                        {tabs.find((t) => t.tab === selectedTab)?.name || i18n.t('select_category')}
                      </span>

                      <svg
                        className={`auction-filter__chevron ${
                          this.state.auctionDropdownOpen ? 'auction-filter__chevron--open' : ''
                        }`}
                        width="16"
                        height="16"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M5 7.5L10 12.5L15 7.5"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>

                    {this.state.auctionDropdownOpen && (
                      <div className="auction-filter__menu">
                        {tabs.map((item, i) => {
                          const count = this.state.is_loading_1
                            ? '...'
                            : this.state.counts[item.tab] || 0;
                          return (
                            <button
                              key={i}
                              className={`auction-filter__option ${
                                selectedTab === item.tab ? 'active' : ''
                              }`}
                              onClick={() => {
                                this.handleTabs(item.tab);
                                this.setState({ auctionDropdownOpen: false });
                              }}
                            >
                              <span>{item.name}</span>
                              <span className="tab-count">{count}</span>
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Auction Content */}
            <div className="col-md-12">
              <div className="items-gallery">
                <div className="items-blog-tab text-center">
                  <div className="tab-content auc-card-wrapper">
                    {this.state.selectedTab === 'all' && (
                      <div className="tab-pane active">
                        <AllAuctions
                          type={this.state.selectedTab}
                          getActiveCount={this.getActiveCount}
                          getImagePopup={this.getImagePopup}
                        />
                      </div>
                    )}

                    {this.state.selectedTab === 'active' && (
                      <div className="tab-pane active">
                        <ActiveAuctions
                          type={this.state.selectedTab}
                          getActiveCount={this.getActiveCount}
                          getImagePopup={this.getImagePopup}
                        />
                      </div>
                    )}

                    {this.state.selectedTab === 'upcoming' && (
                      <div className="tab-pane active">
                        <UpcomingAuctions
                          type={this.state.selectedTab}
                          getUpcomingCount={this.getUpcomingCount}
                          getImagePopup={this.getImagePopup}
                        />
                      </div>
                    )}

                    {this.state.selectedTab === 'featured' && (
                      <div className="tab-pane active">
                        <FeaturedAuctions
                          type={this.state.selectedTab}
                          getImagePopup={this.getImagePopup}
                        />
                      </div>
                    )}

                    {this.state.selectedTab === 'previous' && (
                      <div className="tab-pane active">
                        <PreviousAuctions
                          type={this.state.selectedTab}
                          getImagePopup={this.getImagePopup}
                        />
                      </div>
                    )}

                    {this.state.selectedTab === 'direct' && (
                      <div className="tab-pane active">
                        <DirectAuctions
                          type={this.state.selectedTab}
                          getImagePopup={this.getImagePopup}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {this.state.is_active_light_box && (
          <Lightbox
            images={this.state.lightboxImages}
            onClose={() => {
              this.setState({ is_active_light_box: false });
            }}
          />
        )}
      </React.Fragment>
    );
  }
}
